export default [
  {
    path: '/v2/sishang/company',
    name: '企业信息',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/sishang/company/index.vue`),
    meta: {
      permission: ['set_ssbb_report_firm']
    }
  },
  {
    path: '/v2/sishang/report',
    name: '四上企业报表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/sishang/report/index.vue`),
    meta: {
      permission: ['set_ssbb_report_report']
    }
  },
  {
    path: '/v2/sishang/report/detail',
    name: '四上企业报表详情',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/v2/sishang/report/detail.vue`),
    meta: {
      permission: ['set_ssbb_report_report']
    }
  },
]
